import React, { createContext, useContext, useState } from 'react';

type Density = 'comfortable' | 'compact';

interface DensityContextValue {
  density: Density;
  toggle: () => void;
}

const DensityContext = createContext<DensityContextValue>({
  density: 'comfortable',
  toggle: () => {},
});

export const DensityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [density, setDensity] = useState<Density>('comfortable');
  const toggle = () => setDensity(d => d === 'comfortable' ? 'compact' : 'comfortable');
  return (
    <DensityContext.Provider value={{ density, toggle }}>
      {children}
    </DensityContext.Provider>
  );
};

export const useDensity = () => useContext(DensityContext);
